import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPagination } from 'src/app/shared/models/pagination';
import FilterValues from '../interfaces/ip-filter-values';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QueryParametersService {
  buildQueryParameters(
    sortFieldName: string | string[],
    sortOrder: string | string[],
    pagination: IPagination,
    searchName: string,
    searchValue: string,
    filterValues?: FilterValues,
    statusId?: number,
    ignoredTypeStatus?: number,
    statusCode?: string,
    billed?: boolean,
    supplierId?: number,
    notInSettlement?: boolean,
    isPaid?:boolean,
    saleIdName?: string
  ): HttpParams {
    const queryParameters: { [param: string]: any } = {
      page: pagination.page,
      size: pagination.size,
    };
    if (
      sortFieldName &&
      typeof(sortFieldName) === 'string' &&
      sortFieldName.trim() !== '' &&
      sortOrder &&
      typeof(sortOrder) === 'string' &&
      sortOrder.trim() !== ''
    ) {
      queryParameters['sort'] = `${sortFieldName},${sortOrder}`;
    }
    if (
      sortFieldName &&
      Array.isArray(sortFieldName) &&
      sortOrder &&
      Array.isArray(sortOrder) &&
      sortFieldName.length === sortOrder.length
    ) {
      let sort: string[] = [];     
      for (let i = 0; i < sortFieldName.length; i++) {
        sort.push(`${sortFieldName[i]},${sortOrder[i]}`)
      }
      queryParameters['sort'] = sort;     
    }
    if (searchName && searchName.trim() !== '' && searchValue.trim() !== '') {
      queryParameters[searchName] = searchValue;
    }
    if (filterValues) {
      if (filterValues.amountFrom !== undefined) {
        queryParameters['amountFrom'] = filterValues.amountFrom;
      }
      if (filterValues.amountTo !== undefined) {
        queryParameters['amountTo'] = filterValues.amountTo;
      }
      //TODO fechas
      if (filterValues.createDateFrom && filterValues.createDateTo) {
        queryParameters['createDateFrom'] = filterValues.createDateFrom;
        queryParameters['createDateTo'] = filterValues.createDateTo;
      }
      if (filterValues.createDateFrom !== undefined) {
        queryParameters['createDateFrom'] = filterValues.createDateFrom;
      }
      if (filterValues.createDateTo !== undefined) {
        queryParameters['createDateTo'] = filterValues.createDateTo;
      }
      if (filterValues.brokersId !== undefined) {
        queryParameters['brokersId'] = filterValues.brokersId;
      }
      if(filterValues.statusId !== undefined) {
        queryParameters['statusId'] = filterValues.statusId;
      }
      if(filterValues.ignoreStatusIds !== undefined) {
        queryParameters['ignoreStatusIds'] = filterValues.ignoreStatusIds;
      }
      if(filterValues.statusIds !== undefined) {
        queryParameters['statusIds'] = filterValues.statusIds;
      }
    }
    // For bills:
    if (statusId) {
      queryParameters['statusId'] = statusId;
    }
    if (supplierId) {
      queryParameters['supplierId'] = supplierId;
    }
    if (ignoredTypeStatus) {
      queryParameters['ignoreStatusId'] = ignoredTypeStatus;
    }
    // For settlements:
    if (statusCode) {
      queryParameters['statusCode'] = statusCode;
    }
    if (filterValues?.status !== undefined) {
      queryParameters['statusCode'] = filterValues.status;
    }
    if (billed !== undefined) {
      queryParameters['billed'] = billed;
    }
    if (notInSettlement !== undefined) {
      queryParameters['notInSettlement'] = notInSettlement;
    }
    if (isPaid !== undefined) {
      queryParameters['isPaid'] = isPaid;
    }
    if (saleIdName !== undefined && saleIdName !== null) {
      queryParameters['saleIdName'] = saleIdName;
    }
    return new HttpParams({ fromObject: queryParameters });
  }
}
